module.exports = __webpack_public_path__ + "img/Canada.f712c9ff.svg";